import { useFormContext } from 'react-hook-form';
import FieldContainer from '../../../../shared/FormElements/FieldContainer/FieldContainer';

const haveCurrentSetOptions = [
  { value: 'true', label: 'Yes' },
  { value: 'false', label: 'No' },
];

function WarrantyFormHaveCurrentSet() {
  const { register } = useFormContext();

  return (
    <FieldContainer
      name="haveCurrentSet"
      label="Do you currently have a set of retainers?"
      required={true}
    >
      <div className="mb-4 flex space-x-6">
        {haveCurrentSetOptions.map((option) => (
          <div key={option.value} className="flex items-center">
            <input
              {...register('haveCurrentSet')}
              type="radio"
              value={option.value}
              id={`haveCurrentSet-${option.label}`}
              className="h-4 w-4 border-gray-300 text-rcprimary-400 focus:ring-rcprimary-400"
            />
            <label
              htmlFor={`haveCurrentSet-${option.label}`}
              className="ml-3 block font-medium text-gray-700 text-sm"
            >
              {option.label}
            </label>
          </div>
        ))}
      </div>
    </FieldContainer>
  );
}

export default WarrantyFormHaveCurrentSet;
